import type { ServiceRequestInterface } from '@nts/std/interfaces';

export class ServiceRequest implements ServiceRequestInterface {


}
